import { axiosInstance } from "./api";

export type TCertificateDetails = {
  link: string;
  source: string;
  status: string | null;
  registrationDate: string | null;
  expiryDate: string | null;
  applicant: string | null;
};

export const getCertificateDetails = async ({
  link
}: {
  link: string;
}): Promise<TCertificateDetails> => {
  const res = await axiosInstance.post("/api/v2/certificate/details", { link });
  return res.data;
};
